<script setup lang="ts">
useHead({
  titleTemplate: (title) =>
      title ? `${title} - یاسان` : 'یاسان'
})
</script>

<template>
  <VApp>
    <VLocaleProvider :rtl="true">
      <VMain class="position-relative min-h-screen bg-blue-lighten-5">
        <LayoutsRegisterFlowHeader/>
        <VContainer class="d-flex align-center justify-center py-5 py-md-16">
          <NuxtPage/>
        </VContainer>
      </VMain>
    </VLocaleProvider>
  </VApp>
</template>
